import React from "react";
import { Button, SectionContainer } from "@silversea-ssc/ui-components-react";
import { ImageFragment } from "types/graphql-types";
import BrochurePageBox from "components/BrochurePageBox/BrochurePageBox";

interface TravelGuideProps {
  sectionTitle?: string;
  image?: ImageFragment;
  guideTitle?: string;
  content?: string;
  url?: string;
  ctaText?: string;
}

const TravelGuide: React.FC<React.PropsWithChildren<TravelGuideProps>> = ({
  sectionTitle,
  image,
  guideTitle,
  content,
  url,
  ctaText
}) => {
  const ctaButton = (
    <Button variant="primary" dataContentPiece="view_the_brochures" href={url}>
      {ctaText}
    </Button>
  );
  return (
    <div id="travel_guide" data-content-name="travel_guide">
      <SectionContainer
        backgroundColor="titanium"
        spacingTop="regular"
        spacingBottom="regular"
      >
        <BrochurePageBox
          ctaButton={ctaButton}
          backgroundColor={"white"}
          titleColor={"titanium"}
          sectionTitle={sectionTitle}
          title={guideTitle}
          content={content}
          image={image}
        />
      </SectionContainer>
    </div>
  );
};

export default TravelGuide;
